import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import LexwareConnectButton from "./LexwareConnectButton";

const IntegrationModal = ({ isOpen, onClose, onSave, availableProviders }) => {
  const { t } = useTranslation();
  const [provider, setProvider] = useState("");
  const [apiKey, setApiKey] = useState("");
  // New states for Buchhaltungsbutler
  const [apiClient, setApiClient] = useState("");
  const [apiSecret, setApiSecret] = useState("");

  useEffect(() => {
    if (isOpen) {
      setProvider("");
      setApiKey("");
      setApiClient("");
      setApiSecret("");
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleSave = () => {
    if (provider === "buchhaltungsbutler") {
      if (apiKey && apiClient && apiSecret) {
        onSave(provider, apiKey, apiClient, apiSecret);
      }
    } else if (provider && apiKey) {
      onSave(provider, apiKey);
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <h3>{t("integration_modal_title")}</h3>
          <CloseIcon
            onClick={onClose}
            style={{ cursor: "pointer", color: "#666" }}
          />
        </div>

        <select value={provider} onChange={(e) => setProvider(e.target.value)}>
          <option value="">{t("integration_select_provider")}</option>
          {availableProviders.map((p) => (
            <option key={p} value={p}>
              {p === "lexware_office"
                ? "Lexware Office"
                : p === "buchhaltungsbutler"
                ? "Buchhaltungsbutler"
                : p.toUpperCase()}
            </option>
          ))}
        </select>

        {provider === "wiso" ? (
          <div style={{ margin: "15px 0", textAlign: "center" }}>
            <a
              href="https://app.meinbuero.de/apps/all"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "#1976d2", fontWeight: "bold" }}
            >
              add our WISO-Extension
            </a>
          </div>
        ) : provider === "lexware_office" ? (
          <div style={{ margin: "20px 0", textAlign: "center" }}>
            <p style={{ fontSize: "14px", marginBottom: "15px" }}>
              {t(
                "lexware_oauth_description",
                "You will be redirected to Lexware to authorize this connection.",
              )}
            </p>
            <LexwareConnectButton />
          </div>
        ) : provider === "buchhaltungsbutler" ? (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
              marginTop: "10px",
            }}
          >
            <input
              type="text"
              placeholder="API Client"
              value={apiClient}
              onChange={(e) => setApiClient(e.target.value)}
            />
            <input
              type="text"
              placeholder="API Secret"
              value={apiSecret}
              onChange={(e) => setApiSecret(e.target.value)}
            />
            <input
              type="text"
              placeholder="API Key"
              value={apiKey}
              onChange={(e) => setApiKey(e.target.value)}
            />
          </div>
        ) : (
          <input
            type="text"
            placeholder={t("integration_enter_api_key")}
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
          />
        )}

        <div className="modal-buttons">
          <button onClick={onClose} className="cancel-btn">
            {t("integration_cancel")}
          </button>
          {provider !== "wiso" && provider !== "lexware_office" && (
            <button
              onClick={handleSave}
              className="confirm-btn"
              disabled={
                !provider ||
                (provider === "buchhaltungsbutler"
                  ? !apiKey || !apiClient || !apiSecret
                  : !apiKey)
              }
              style={{ display: "flex", alignItems: "center", gap: "5px" }}
            >
              <SaveIcon fontSize="small" /> {t("integration_save")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default IntegrationModal;
